import { render, staticRenderFns } from "./Trade-Center-Account-Flow.vue?vue&type=template&id=aa57d8b0&scoped=true"
import script from "./Trade-Center-Account-Flow.vue?vue&type=script&lang=js"
export * from "./Trade-Center-Account-Flow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa57d8b0",
  null
  
)

export default component.exports